import { render, staticRenderFns } from "./materialsApply.vue?vue&type=template&id=143f0516&scoped=true&"
import script from "./materialsApply.vue?vue&type=script&lang=js&"
export * from "./materialsApply.vue?vue&type=script&lang=js&"
import style0 from "./materialsApply.vue?vue&type=style&index=0&id=143f0516&prod&lang=scss&scoped=true&"
import style1 from "./materialsApply.vue?vue&type=style&index=1&id=143f0516&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143f0516",
  null
  
)

export default component.exports